import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseModalModule } from '@app/shared/components/modal/base-modal/base-modal.module';
import { LoaderComponent } from '@app/shared/components/loader/loader.component';

@Component({
  selector: 'app-profile-base-form',
  templateUrl: './profile-base-form.component.html',
  styleUrls: ['./profile-base-form.component.scss'],
  host: {
    '[class.profile-base-form]': 'true',
  },
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslatePipe, BaseModalModule, LoaderComponent, ReactiveFormsModule],
})
export class ProfileBaseFormComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() isContentLoading!: boolean;
  @Input() title!: string;
  @Output() formOnSubmit = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  submit() {
    this.formOnSubmit.emit();
  }
}
